module.exports = __webpack_public_path__ + "1c12ffda4bc16054e1e246f48bfcee06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-santa.png
// module id = 2287
// module chunks = 0